import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import {usePersonasMutations} from '../../hooks/personas/usePersonasMutations'
import {getPersonas} from "../../services/Personas";

import DataTable from 'react-data-table-component';
import { NuevaPersona } from '../../components';


const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const formatDateDMY = (dateStr) => {
  if (!dateStr) return '';
  try {
    const d = new Date(dateStr);
    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    const year = d.getUTCFullYear();
    return `${day}-${month}-${year}`;
  } catch (e) {
    return '';
  }
};

const Personas = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removePersona} = usePersonasMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [PersonaFiltro, setNombrePersonaFiltro] = useState("");
  const [filteredData, setFilteredData] = useState([]);


  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getPersonas();
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[]);

  useEffect(() => {
    if (PersonaFiltro.trim() === "") {
      setFilteredData(sucursalesData);
    } else {
      const f = PersonaFiltro.toLowerCase();
      setFilteredData(
        sucursalesData.filter((item) =>
          (item.rut || '').toLowerCase().includes(f) ||
          (item.nombres || '').toLowerCase().includes(f) ||
          (item.apellidoPaterno || '').toLowerCase().includes(f) ||
          (item.apellidoMaterno || '').toLowerCase().includes(f) ||
          (item.email || '').toLowerCase().includes(f)
        )
      );
    }
  }, [PersonaFiltro, sucursalesData]);

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('NuevaPersona');
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removePersona.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
  
        const losFiados = await getPersonas();
    
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Rut',
      selector: row => row.rut,
      sortable: true
    },
    {
      name: 'Nombres',
      selector: row => row.nombres,
      sortable: true
    },
    {
      name: 'Apellido Paterno',
      selector: row => row.apellidoPaterno,
      sortable: true
    },
    {
      name: 'Apellido Materno',
      selector: row => row.apellidoMaterno,
      sortable: true
    },
    {
      name: 'Email',
      selector: row => row.email,
      sortable: true
    },
    {
      name: 'Teléfono',
      selector: row => row.telefonoMovil,
      sortable: true
    },
    {
      name: 'Fecha Nacimiento',
      selector: row => formatDateDMY(row.fechaNacimiento),
      sortable: true
    },
    {
      name: 'Fecha Creación',
      selector: row => formatDateDMY(row.fechaCreacion),
      sortable: true
    },
  ];

  return (
    <>
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Personas
              </p>
            </div>
        </div>
      <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
        <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 w-full justify-end">
            <div className="flex flex-col justify-end">
              <NavButton title="Agregar Persona" customFunc={() => { setLaSucursal(''); handleClick('NuevaPersona')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nueva Persona'} />
            </div>
            <div className="flex flex-col justify-end">
              <label className="text-xs font-semibold mb-1 whitespace-nowrap">Buscar Persona</label>
              <input
                type="text"
                className="text-xs border border-gray-300 p-2 rounded w-full"
                placeholder="Ej: 12.345.678-9 o nombre"
                value={PersonaFiltro}
                onChange={e => setNombrePersonaFiltro(e.target.value)}
              />
            </div>
          </div>
        </div>
      </div>

    <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
        <div className="flex flex-col">
          <DataTable
            columns={columns}
            data={filteredData}
            highlightOnHover={true}
            pagination={true}
            striped={true}
            selectableRowsHighlight={true}
            customStyles={customStyles}
            noHeader={true}
            noDataComponent={'No hay Personas creados'}
          />
        </div>
      </div>
    </div>
     {isClicked.NuevaPersona && (<NuevaPersona vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}

  </div>
    </>

  );
};

export default Personas;